import React from "react";
import { StyledModal, StyledH2 } from "@aureskonnect/react-ui";
import { ModalHeader } from "reactstrap";

import { ArchiveBody } from "./ConfirmationArchiveParts/ArchiveBody";
import { ArchiveFooter } from "./ConfirmationArchiveParts/ArchiveFooter";
import { useArchiveActions } from "./ConfirmationArchiveParts/useArchiveActions";

type ConfirmationArchiveType = {
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    isModalOpened: boolean;
    e?: { selectedRow: FidelityRow };
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    selectedRows: FidelityRow[];
    setLimit?: React.Dispatch<React.SetStateAction<number>>;
    setCodeSupport?: React.Dispatch<React.SetStateAction<string>>;
};

export function ConfirmationArchive({
    setIsModalOpened,
    isModalOpened,
    e,
    selectedRows,
    setCodeSupport,
}: ConfirmationArchiveType) {
    const { t, cancel, confirm } = useArchiveActions({
        setIsModalOpened,
        selectedRows,
        e,
        setCodeSupport,
    });

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader className="text-capitalize" toggle={cancel}>
                <StyledH2 className="text-uppercase">{t("Alert")}</StyledH2>
            </ModalHeader>
            <ArchiveBody
                message={t(
                    "Attention, this fidelity setting(s) can be used by other modules.\n Do you want to confirm the archiving of the selected fidelity setting(s)?"
                )}
            />
            <ArchiveFooter
                cancelLabel={t("Cancel")}
                validateLabel={t("Validate")}
                onCancel={cancel}
                onValidate={confirm}
            />
        </StyledModal>
    );
}
